// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"2ffe4d7d","106":"63e00312","330":"8e52042c","369":"544ba771","415":"1ef9da45","477":"627db9d4","503":"eb512f4e","563":"5e6a92ad","580":"644c2905","606":"297f5c23","617":"00d2aaef","623":"117e4cd0"}[chunkId] + ".chunk.js";
};